import { createFileRoute, Link, notFound } from "@tanstack/react-router";
import { z } from "zod";
import { Button } from "@/components/ui/button";
import { roadmapQuery } from "@/features/roadmap/queries";
import { RoadmapEditor } from "@/features/roadmap/RoadmapEditor";
import { ApiError } from "@/lib/api";

const searchSchema = z.object({
  /** Number of days visible across the timeline viewport. */
  zoom: z.number().int().min(1).optional().catch(undefined),
  /** Read-only presentation mode: no editing chrome. */
  present: z.boolean().optional().catch(undefined),
  /** Comma-separated phase names hidden on the timeline (see lib/phases.ts). */
  hide: z
    .union([z.string(), z.number(), z.boolean()])
    .transform(String)
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute("/_authed/r/$roadmapId")({
  validateSearch: (search) => searchSchema.parse(search),
  loader: async ({ context, params }) => {
    try {
      await context.queryClient.ensureQueryData(roadmapQuery(params.roadmapId));
    } catch (err) {
      if (err instanceof ApiError && err.status === 404) throw notFound();
      throw err;
    }
  },
  notFoundComponent: () => (
    <div className="flex h-full flex-col items-center justify-center gap-3 text-center">
      <p className="text-lg font-medium">This roadmap does not exist</p>
      <Button asChild variant="outline">
        <Link to="/">Back to roadmaps</Link>
      </Button>
    </div>
  ),
  component: () => {
    const { roadmapId } = Route.useParams();
    const search = Route.useSearch();
    return <RoadmapEditor key={roadmapId} roadmapId={roadmapId} search={search} />;
  },
});
